<template>
  <div class="bg-base-100 rounded-lg p-6">
    <div
      class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4 mb-8"
    >
      <h2 class="text-xl font-semibold text-base-content">
        Valdomų transporto priemonių sąrašas
      </h2>
      <div>
        <router-link to="/vehicles/new" class="btn btn-sm btn-success">
          <DefaultIcon name="plus" size="w-4 h-4" />
          Naują
        </router-link>
      </div>
    </div>

    <div v-if="vehicleStore.isLoading" class="text-center py-4">
      <span class="loading loading-spinner loading-lg"></span>
    </div>

    <div v-else class="overflow-x-auto">
      <div v-if="vehicleStore.vehicles.length > 0">
        <table class="table w-full">
          <thead>
            <tr>
              <th>Nuotrauka</th>
              <th>Valstybinis numeris</th>
              <th>Pavadinimas</th>
              <th>Aprašymas</th>
              <th>Sėdimos vietos (įprastos)</th>
              <th>Sėdimos vietos (neįgaliesiems)</th>
              <th>Kuro sąnaudos</th>
              <th>Veiksmai</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="vehicle in vehicleStore.vehicles" :key="vehicle.id">
              <td>
                <div class="avatar">
                  <div class="w-28 rounded-sm">
                    <img :src="vehicle.img_url" :alt="vehicle.model" />
                  </div>
                </div>
              </td>
              <td>{{ vehicle.reg_nr }}</td>
              <td>{{ vehicle.model }}</td>
              <td>{{ vehicle.description }}</td>
              <td>{{ vehicle.seats_regular }}</td>
              <td>{{ vehicle.seats_disabled }}</td>
              <td>{{ vehicle.fuel_consumption }}</td>
              <td>
                <div class="flex gap-2">
                  <router-link
                    :to="'/vehicles/' + vehicle.id + '/edit'"
                    class="btn btn-sm btn-ghost btn-circle"
                    title="Redaguoti įrašą"
                  >
                    <DefaultIcon name="editPencil" size="w-4 h-4" />
                  </router-link>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else>
        Jūs dar neįtraukėte nė vienos transporto priemonės. Įtraukite naują
        transporto priemonę paspaudę mygtuką - Įtraukti naują.
      </div>
    </div>
  </div>
</template>

<script setup>
import { useVehicleStore } from "@/stores/vehicles";
import { onMounted } from "vue";
import DefaultIcon from "@/components/icons/DefaultIcon.vue";

const vehicleStore = useVehicleStore();

onMounted(async () => {
  try {
    await vehicleStore.fetchVehicles();
  } catch (error) {
    console.error("Failed to fetch vehicles:", error);
  }
});
</script>
